export default __webpack_public_path__ + "static/media/Cacherules.368b7794.mp4";